import Http from "../http";

class CouponServices {
  static async getCoupons() {
    return Http.get("/coupons");
  }
  static async getCouponById(id) {
    return Http.get(`/coupon/${id}`);
  }
  // static async getDriverTripcount(id){
  //     return Http.get(`/rider-trip-counts/${id}`);
  // }
  static async updateCoupon(id, data) {
    console.log(
      "========================================data in the updateCoupon",
      data
    );
    return Http.update(`/coupon/${id}`, data);
  }
  static async addCoupon(data) {
    return Http.post("/coupon/create", data);
  }

  static async deleteCoupon(id) {
    return Http.delete(`/coupon/${id}`);
  }
}
export default CouponServices;
